import { Injectable } from '@angular/core';

function findValueInObject(keys: string[], source: any): any | boolean {
  for (const key of keys) {
    const keySplitted = key.split(key.indexOf('.') > -1 ? '.' : ' ');
    const value = keySplitted.reduce((p, c) => p && p[c] || undefined, source);
    if (value) {
      return value;
    }
  }

  return false;
}

@Injectable({
  providedIn: 'root'
})
export class JsonPickService {

  pick(value, prop, fallbacks: string[] = ['en']) {
    try {
      const data = JSON.parse(value);
      const val = findValueInObject([prop], data);
      if (val) return val;
      const fallbackVal = findValueInObject(fallbacks.filter((f) => f !== prop), data);
      return fallbackVal || '';
    } catch (e) {
      return value;
    }
  }
}
